import { Step } from 'react-joyride'
import { useSelector } from 'react-redux'
import { IUserRoles } from 'shared/models/User'
import { getBblDisplayNames } from 'shared/store/bbl'
import { getClientIdsForUser } from 'shared/utils/rolesHelper'
import WelcomeStep from './WelcomeStep'

const useOnboardingSteps = () => {
  const { myPage } = useSelector(getBblDisplayNames)

  // Steps
  const welcomestep: Step = {
    target: '.appwrapper',
    content: <WelcomeStep />,
    skipBeacon: true,
    placement: 'center',
  }

  const mainmenustep: Step = {
    target: '.menuwrapper',
    title: 'Hovedmeny',
    content: 'Her finner du hovedmenyen',
    placement: 'right',
  }

  const mysiteshortcutstep: Step = {
    target: '.mysite-shortcut',
    title: myPage,
    content: `Her finner du snarvei til ${myPage}`,
    placement: 'right',
    skipBeacon: true,
  }

  const relationpickerstep: Step = {
    target: '.relation-picker',
    title: 'Bytt boligselskap',
    content: 'Her kan du bytte mellom boligselskap du er tilknyttet',
    skipBeacon: true,
  }

  const mobilemenustep: Step = {
    target: '.mobilemenutoggle',
    title: 'Meny',
    content: `Her finner du hovedmenyen. I menyen finner du snarvei til ${myPage}`,
    placement: 'left',
  }

  const mobilemenustepwithmorecompanies: Step = {
    target: '.mobilemenutoggle',
    title: 'Meny',
    content: `Her finner du menyen. I menyen kan du bytte mellom boligselskap du er pålogget, og finner snarvei til ${myPage}`,
    placement: 'left',
  }

  // Utils
  const getOnboardingMobileSteps = (roles: IUserRoles[]) => {
    const res = [welcomestep]
    res.push(
      getClientIdsForUser(roles).length > 1
        ? mobilemenustepwithmorecompanies
        : mobilemenustep
    )
    return res
  }

  return {
    mainmenustep,
    mysiteshortcutstep,
    relationpickerstep,
    welcomestep,
    getOnboardingMobileSteps,
  }
}

export default useOnboardingSteps
